import { render, staticRenderFns } from "./MTextFieldHeaderComp.vue?vue&type=template&id=31c3dc81&"
import script from "./MTextFieldHeaderComp.vue?vue&type=script&lang=js&"
export * from "./MTextFieldHeaderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports